import { TokenValues } from "@silversea-ssc/dotcom-read-model-types/Tokens";
import { isPresent } from "src/utils/checks";
import { Currency } from "src/utils/localization/currency";
import { formatI18nCurrency } from "src/utils/localization/formatCurrency";

export type CruiseShorexCredit = {
  amount: number;
  currency: Currency;
};

export const shorexCreditFromTokens = (
  tokens: TokenValues | undefined
): CruiseShorexCredit | undefined => {
  const shorexCredit = tokens?.["shorex_credit"];
  return isPresent(shorexCredit) &&
    shorexCredit.type == "amount" &&
    shorexCredit.amount > 0
    ? { amount: shorexCredit.amount, currency: shorexCredit.currency }
    : undefined;
};

export const formatShorexCredit = (
  shorexCredit: CruiseShorexCredit | undefined
): string | undefined => {
  if (!isPresent(shorexCredit) || shorexCredit.amount <= 0) return undefined;
  return formatI18nCurrency(shorexCredit.amount, shorexCredit.currency);
};
